import axios from "axios";

export const apiUrl = process.env.REACT_APP_API_URL;
export const uploadUrl = process.env.REACT_APP_UPLOAD_URL;

const API = axios.create({
  baseURL: apiUrl,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const loginAdmin = async (username, password) => {
  const response = await API.post("/auth/login", { username, password });
  return response.data;
};

export const getData = async (endpoint) => {
  const response = await API.get(endpoint);
  return response.data;
};

export const postData = async (endpoint, data) => {
  const response = await API.post(endpoint, data);
  return response.data;
};

export const putData = async (endpoint, data) => {
  const response = await API.put(endpoint, data);
  return response.data;
};

export const deleteData = async (endpoint) => {
  const response = await API.delete(endpoint);
  return response.data;
};

export default API;
